<template>
  <v-client-table
    :data="tableItems"
    :columns="table.columns"
    :options="table.options"
    class="table-default"
  >
    <template #h__number><div class="table-default__left">Number</div></template>
    <template #number="{ row }"><div class="table-default__left">{{ row.number }}</div></template>
    <template #group="{ row }">{{ row.group.name }}</template>
    <template #type="{ row }">{{ row.type.name }}</template>
    <template #supplier="{ row }">{{ row.supplier.legal_name }}</template>
    <template #dates="{ row }">
      {{ dateFormat(row.start) }} - {{ dateFormat(row.finish) }}
    </template>
    <template #amount_paid="{ row }">
      {{ row.amount_paid.toLocaleString() }} {{ row.amount_paid_currency.code }}
    </template>
    <template #attachment="{ row }">
      <div class="table-default__controls">
        <button
          @click="downloadFile(row.attachment, row)"
          type="button"
        >
          <img src="@/assets/img/download-table-blue-icon.svg" alt="">
        </button>
      </div>
    </template>
  </v-client-table>
</template>

<script>
export default {
  name: 'TableInsurancesExpiring',
  props: ['tableItems', 'dateFormat', 'downloadFile'],
  data() {
    return {
      table: {
        columns: ['number', 'group', 'type', 'supplier', 'value', 'dates', 'amount_paid', 'attachment'],
        options: {
          headings: {
            number: 'Number',
            group: 'Group',
            type: 'Type',
            supplier: 'Supplier',
            value: 'Value',
            dates: 'Dates',
            amount_paid: 'Amount paid',
            attachment: 'Attachment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
}
</script>
